const TileLayoutModel = {
  SLIDING: 'SLIDING',
  STACKED: 'STACKED',
};

export default TileLayoutModel;
